import "can/construct/";
import "can/view/stache/";
import SwitchAccountViewModel from "./switch-account-view-model";
import SidebarMenuAccessList from "src/components/sidebar/sidebar-menu-access-list";
import InitCompanies from "src/components/license-management/overview/init-companies";
import _remove from "lodash/remove";
import _filter from "lodash/filter";
import _forEach from "lodash/forEach";
import UserPermission from "src/components/shared/user-permissions";


export default can.Construct.extend({
    create: function () {
        "use strict";
        let viewModel = new SwitchAccountViewModel(),
            $dialogMsg = null,
            allAccounts = [],
            $this = this;

        $this.accessList = new SidebarMenuAccessList();
        BootstrapDialog.show({
            title: Locale.translate("Switch Account"),
            id: "switch-account-modal",
            size: "size-small",
            closeByBackdrop: false,

            message: can.view("src/components/shared/switch-account.stache", viewModel),

            onshow: function (dialog) {
                $dialogMsg = dialog.$modalBody.find(".bootstrap-dialog-message");
                viewModel.attr("dialog", dialog);

                VtAdmin.Modules.set($dialogMsg, ["input"]);

                // Disable `Switch` button by default
                if (dialog && dialog.indexedButtons && dialog.indexedButtons.save && typeof dialog.indexedButtons.save.prop === "function") {
                    dialog.indexedButtons.save.prop("disabled", true);
                }
                Vistracks.HelperUtils.modal.setHeight(dialog);

                let resizeId;
                $(window)
                    .resize(function () {
                        clearTimeout(resizeId);
                        resizeId = setTimeout(function () {
                            Vistracks.HelperUtils.modal.setHeight(dialog);
                        }, 20);
                    });
            },

            onshown: (dialog) => {
                $dialogMsg.find("#search-account").focus();

                viewModel.attr("placeholder", "Select Account");
                viewModel.attr("accountsPromise")
                    .done(() => {
                        if (viewModel.attr("accounts").length === 0) {
                            $dialogMsg.find("#page-description")
                                .text(Locale.translate("You don't have any sub-accounts."));
                        } else {
                            let childAccounts = $dialogMsg.find("#child-accounts");
                            _forEach(viewModel.attr("accounts"), account => {
                                this.getChildren(account, childAccounts);
                            });

                            _forEach(viewModel.attr("accounts"), account => {
                                $this.addSubs(account, allAccounts);
                            });

                            viewModel.attr("allAccounts", allAccounts);
                            viewModel.attr("flattenedAccounts", allAccounts);

                            let groups = childAccounts.find("[role='group']"),
                                accounts = childAccounts.find(".account");

                            _(groups)
                                .forEach((item) => {
                                    let $el = $(item);
                                    $el.prepend("<i class='fa fa-plus fa-fw'></i>");
                                });

                            $("#child-accounts").on("click", "span.account", function (e) {
                                var $el = $(this),
                                    accId = $el.attr("data-id");

                                $("#child-accounts span.account").removeClass("selected");
                                $el.addClass("selected");

                                if ($el.siblings("i.fa").length > 0) {
                                    if ($el.siblings("i.fa").hasClass("fa-plus")) {
                                        $el.siblings("i.fa").removeClass("fa-plus").addClass("fa-minus");

                                        if (!$(this).hasClass("rendered")) {
                                            viewModel.renderSubAccounts(accId, allAccounts);
                                            $el.siblings("ul").slideDown();
                                            $(this).addClass("rendered")
                                        } else {
                                            $el.siblings("ul").slideDown();
                                        }
                                    } else {
                                        $el.siblings("i.fa").removeClass("fa-minus").addClass("fa-plus");
                                        $el.siblings("ul").slideUp();
                                    }
                                }

                                viewModel.attr("selectedAccount", parseInt(accId, 10));
                                viewModel.attr("selectedAccountName", $el.text());
                                if (dialog && dialog.indexedButtons && dialog.indexedButtons.save && typeof dialog.indexedButtons.save.prop === "function") {
                                    dialog.indexedButtons.save.prop("disabled", false);
                                }
                            })

                            $("#switch-account").on("dblclick", ".account", function () {
                            if (dialog && dialog.indexedButtons && dialog.indexedButtons.save && typeof dialog.indexedButtons.save.trigger === "function") {
                                dialog.indexedButtons.save.trigger("click");
                            }
                            });
                        }
                    })
                    .fail(function () {
                        $dialogMsg.find("#page-description").text(Locale.translate("You don't have any sub-accounts."));
                    });
            },

            onhidden: function () {
                viewModel.attr("dialog", "");
            },

            buttons: [
                {
                    label: Locale.translate("Switch"),
                    id: "save",
                    cssClass: "btn btn-link waves-effect",
                    hotkey: 13,
                    action: function (dialog) {
                        const deactivatedSubAccount = $this.getDeactivatedSubAccountById(viewModel.attr("accounts"), viewModel.attr("selectedAccount"));
                        if (deactivatedSubAccount) {
                            BootstrapDialog.show({
                                type: "type-warning",
                                title: Locale.translate("Warning"),
                                size: "size-small",
                                message: Locale.translate("The account you are trying to Switch is deactivated. Do you want to continue?"),
                                buttons: [{
                                    label: Locale.translate("Yes"),
                                    cssClass: "btn btn-link waves-effect",
                                    action: function (dialog) {
                                        dialog.close();
                                        $this.switchToSelectedAccount($this, viewModel, dialog);
                                    }
                                }, {
                                    label: Locale.translate("No"),
                                    cssClass: "btn btn-link waves-effect",
                                    action: function (dialog) {
                                        if (dialog) {
                                            dialog.close();
                                        }
                                        dialog.close();
                                    }
                                }]
                            });
                        } else {
                            $this.switchToSelectedAccount($this, viewModel, dialog);
                        }
                    }
                },
                {
                    label: Locale.translate("Close"),
                    cssClass: "btn btn-link waves-effect",
                    action: dialog => dialog.close()
                }
            ]
        });
    },

    switchToSelectedAccount: function ($this, viewModel, dialog) {
        Cookies.remove("routes", {
            path: "/",
            secure: true,
            sameSite: "None"
        });

        if (
            parseInt(viewModel.attr("selectedAccount"), 10) === Vistracks.myUser.accountId
        ) {
            Cookies.remove("VT-On-Behalf-Of", {
                path: "/",
                secure: true,
                sameSite: "None"
            });
        } else {
            Cookies.set("VT-On-Behalf-Of", viewModel.attr("selectedAccount"), {
                path: "/",
                secure: true,
                sameSite: "None"
            });
        }
        let $dialogMsg = dialog.$modalBody.find(".bootstrap-dialog-message");
        const acc = $dialogMsg.find("#choose-account");
        const cog = $dialogMsg.find("#switching-account");

        dialog.$modalBody.css("height", dialog.$modalBody.outerHeight());
        acc.css("display", "none");
        cog.css("display", "block");

        $("#switch-name").text(viewModel.attr("selectedAccountName"));

        setTimeout(() => {
            $this.accessList.triggerAccess();

            _.delay(() => {
                Vistracks.Scope.Refresh.refreshData(true);
                Vistracks.Scope.AppState.attr(
                    "account",
                    viewModel.attr("selectedAccountName")
                );
            }, 1000);

            $("#accountLogo").css("background-color", "#3b4e56");
            $("#accountLogo").html("");
        }, 100);

        setTimeout(() => {
            var image = new Image();
            image.src =
                "/api/v2/branding/applicationLogo?image=header&" + new Date().getTime();
            image.onload = function () {
                if (image.width > 0) {
                    $("#accountLogo").css("background-color", "#ffffff");

                    $("#accountLogo").html(image);
                }
            };
        }, 500);

        _.delay(() => {
            const currentLocation = window.location.href;

            dialog.close();
            window.location.reload(currentLocation);
        }, 1100);
    },

    getChildren: function (account, el) {
        "use strict";
        let self = this,
            groupParent = "<li role='group' group-id='" + account.id + "'></li>",
            groupChild = "<li group-id='" + account.id + "'></li>",
            spanChild = "<span data-id='" + account.id + "' class='account group-label'>" + account.name + "</span>",
            groupChildren = "<ul id='sub-accounts' style='display:none' subs-id='" + account.id + "'></ul>";

        if (account.subAccounts !== undefined) {
            el.append(groupParent);

            let els = el.find("[group-id='" + account.id + "']");
            els.append(spanChild);
            els.append(groupChildren);
        } else {
            el.append(groupChild);
            let els = el.find("[group-id='" + account.id + "']");
            els.append(spanChild);
        }
    },

    appendChildren: function (account, el, allAccounts) {
        "use strict";
        let self = this,
            spanChild = "<span data-id='" + account.id + "' class='account group-label'>" + account.name + "</span>";

        if (account.subAccounts !== undefined) {
            self.getChildren(account, el, allAccounts);
        } else {
            allAccounts.push({
                id: account.id,
                name: account.name,
                lname: account.name.toLowerCase()
            });
        }
    },

    getDeactivatedSubAccountById: function (accounts, id) {
        let foundAccount = null;

        _.forEach(accounts, (account) => {
            if (account.subAccounts) {
                _.forEach(account.subAccounts, (subAccount) => {
                    if (subAccount.id === id && subAccount.deactivated) {
                        foundAccount = subAccount;
                        return false;
                    }
                    if (subAccount.subAccounts) {
                        _.forEach(subAccount.subAccounts, (subSubAccount) => {
                            if (subSubAccount.id === id && subSubAccount.deactivated) {
                                foundAccount = subSubAccount;
                                return false;
                            }
                        });
                        if (foundAccount) return false;
                    }
                });
                if (foundAccount) return false;
            }
        });

        return foundAccount;
    },

    addSubs: function (account, allAccounts) {
        if (account.hasOwnProperty("subAccounts")) {
            allAccounts.push({
                id: account.id,
                name: account.name,
                lname: account.name.toLowerCase(),
                subAccounts: account.subAccounts
            });
            _.forEach(account.subAccounts, (a) => {
                this.addSubs(a, allAccounts);
            });
        } else {
            allAccounts.push({
                id: account.id,
                name: account.name,
                lname: account.name.toLowerCase()
            });
        }

    }
});
